/* Zettler Digital — page-content lightbox (snippets/zd-lightbox-button.liquid) */
(function () {
  if (window.zdLightboxInit) return;
  window.zdLightboxInit = true;

  function openLightbox(trigger) {
    var dialog = document.getElementById(trigger.getAttribute('data-zd-lightbox-open'));
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    dialog._zdTrigger = trigger;
    dialog.showModal();
    document.documentElement.classList.add('zd-lb-open');
    var panel = dialog.querySelector('.zd-lightbox__panel');
    if (panel) panel.scrollTop = 0;
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-zd-lightbox-open]');
    if (trigger) {
      if (openLightbox(trigger)) e.preventDefault();
      return;
    }

    var close = e.target.closest('[data-zd-lightbox-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d) d.close();
      return;
    }

    // Click on the backdrop (the dialog element itself, outside the panel)
    if (e.target.matches && e.target.matches('dialog.zd-lightbox[open]')) {
      e.target.close();
    }
  });

  // role="button" anchors should also respond to the Space key
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var trigger = e.target.closest && e.target.closest('[data-zd-lightbox-open]');
    if (trigger && openLightbox(trigger)) e.preventDefault();
  });

  // Fires for Esc and for .close(); restore scroll and focus
  document.addEventListener(
    'close',
    function (e) {
      var d = e.target;
      if (!d.classList || !d.classList.contains('zd-lightbox')) return;
      if (!document.querySelector('dialog.zd-lightbox[open]')) {
        document.documentElement.classList.remove('zd-lb-open');
      }
      if (d._zdTrigger && typeof d._zdTrigger.focus === 'function') {
        d._zdTrigger.focus();
      }
    },
    true
  );

  // Theme editor: close any open lightbox when its section is re-rendered
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('zd-lb-open');
  });
})();
